module.exports = __webpack_public_path__ + "static/media/o-comparison.3f0cd6e9.png";